import React, { Component } from 'react'
import PropTypes from 'prop-types'
import xorBy from 'lodash/xorBy'
import some from 'lodash/some'
import find from 'lodash/find'
import isEqual from 'lodash/isEqual'
import classNames from 'classnames'

import ButtonOption from './ButtonOption'

class OptionGroup extends Component {
  static propTypes = {
    items: PropTypes.array,
    itemToString: PropTypes.func,
    renderItem: PropTypes.func,
    onChange: PropTypes.func,
    selectedItems: PropTypes.array.isRequired,
    single: PropTypes.bool,
    noStyle: PropTypes.bool,
    required: PropTypes.bool,
    className: PropTypes.string
  }

  static defaultProps = {
    selectedItems: [],
    itemToString: item => item
  }

  toggleItem = item => {
    const { onChange, single, required, selectedItems } = this.props

    let newSelectedItems

    if (single) {
      const isSelected = !!find(selectedItems, x => isEqual(x, item))
      newSelectedItems = isSelected ? [] : [item]
    } else {
      newSelectedItems = xorBy(selectedItems, [item], JSON.stringify)
    }

    if (required && newSelectedItems.length === 0) {
      newSelectedItems = selectedItems
    }

    if (onChange) {
      onChange(newSelectedItems)
    }

    return newSelectedItems
  }

  isSelected = item => {
    return some(this.props.selectedItems, x => isEqual(x, item))
  }

  render () {
    const {
      items,
      itemToString,
      renderItem,
      noStyle,
      className,
      disabled
    } = this.props
    const wrapperClasses = classNames({
      'option-group': true,
      [className]: className,
      'option-group--no-style': noStyle
    })

    return (
      <div className={`${wrapperClasses}`}>
        {items.map((item, i) => {
          const optionClasses = classNames({
            'option-group__option': true,
            'option-group__option--selected': this.isSelected(item)
          })

          if (renderItem) {
            return renderItem({
              item,
              itemToString,
              disabled,
              toggleItem: this.toggleItem,
              isSelected: this.isSelected,
              className: optionClasses
            })
          }

          return (
            <ButtonOption
              item={item}
              className={optionClasses}
              itemToString={itemToString}
              key={i}
              toggleItem={this.toggleItem}
            />
          )
        })}
      </div>
    )
  }
}

export default OptionGroup
